// Temporary solution to unblock a big client of using part of G+ features
export const clientIdGodMod = 'a81441a6-ca7d-4128-8528-3f0bebef6077';
